import cx from "classnames";
import React from "react";
import styles from "./BlockButtonGroup.scss";

export const BlockButtonGroup = ({
  options,
  selected,
  onChange,
  alignOptions,
  className,
  itemClassName,
  selectedItemClassName,
}) => {
  const flexBasis = `${(1 / options.size) * 100}%`;
  return (
    <div className={cx(styles.BlockButtonGroup, className)}>
      {options
        .map((v, k) => (
          <GroupItem
            key={k}
            v={v}
            k={k}
            selected={k === selected}
            onChange={onChange}
            alignOptions={alignOptions}
            itemClassName={itemClassName}
            selectedItemClassName={selectedItemClassName}
            flexBasis={flexBasis}
          />
        ))
        .toIndexedSeq()}
    </div>
  );
};

const GroupItem = ({ v, k, selected, onChange, flexBasis, alignOptions, itemClassName, selectedItemClassName }) => (
  <button
    style={{ flexBasis, textAlign: alignOptions ?? "center" }}
    className={cx(styles.groupItem, selected && styles.selected, itemClassName, selected && selectedItemClassName)}
    onClick={(e) => {
      e.preventDefault();
      onChange(k);
    }}
  >
    {v}
  </button>
);
